import styled from "styled-components";

export const Box = styled.div`
  /* Base container styles */

  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  .ctr-container {
    // background: #f5f7fa; /* Softer background for better contrast */
    // min-height: 100vh;
    // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    //   Ubuntu, Cantarell, sans-serif;
    padding: 3rem 1rem; /* Increased padding for breathing room */
  }

  /* Card styles */
  .ctr-calculator-card {
    background-color: white;
    border-radius: 20px; /* Slightly larger border-radius for a modern look */
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08); /* Softer, larger shadow */
    padding: 1.5rem;
    max-width: 900px;
    margin: 0 auto;
    transition: transform 0.3s ease; /* Smooth scaling on hover */
  }

  .ctr-calculator-card:hover {
    transform: translateY(-3px); /* Subtle lift effect on hover */
  }

  /* Header styles */
  .ctr-header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem; /* Slightly larger gap for better spacing */
    margin-bottom: 2.5rem;
  }

  .ctr-fs-2 {
    font-size: 2.25rem; /* Slightly larger for emphasis */
    font-weight: 700;
    color: #1a202c; /* Darker text for better contrast */
    letter-spacing: -0.025em;
  }

  .ctr-icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: linear-gradient(135deg, #e0e7ff, #c7d2fe);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.15); /* Subtle shadow for depth */
  }

  .ctr-calculator-icon {
    color: #4f46e5;
  }

  /* Form grid layout */
  .ctr-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.75rem; /* Slightly larger gap for better spacing */
    // margin-bottom: 2.5rem;
  }

  /* Button container to ensure buttons span the full width */
  .ctr-button-container {
    grid-column: 1 / -1; /* Span the entire width of the grid */
    margin-top: 1.5rem;
  }

  /* Button group styles */
  .ctr-button-group {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }

  /* Form group styles */
  .ctr-form-group {
    display: flex;
    flex-direction: column;
  }

  .ctr-form-group label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #2d3748; /* Slightly darker for better readability */
    margin-bottom: 0.5rem;
    letter-spacing: 0.02em;
  }

  /* Input and select styles */
  .ctr-custom-input,
  .ctr-custom-select {
    height: 52px; /* Slightly taller for better touch target */
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    color: #1f2937;
    background-color: #f9fafb; /* Light background for inputs */
    transition: all 0.2s ease-in-out;
  }

  .ctr-custom-input:focus,
  .ctr-custom-select:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.15); /* Larger, softer focus ring */
    background-color: white;
    outline: none;
  }

  .ctr-custom-input::placeholder {
    color: #9ca3af; /* Softer placeholder color */
  }

  .ctr-custom-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23374151' viewBox='0 0 16 16'%3E%3Cpath d='M8 12l-4-4h8l-4 4z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 14px; /* Slightly larger arrow */
  }

  /* Button styles */
  .ctr-btn {
    height: 52px;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.2s ease-in-out;
  }

  .ctr-btn-primary {
    background-color: #8cc540;
    border: none;
    color: white;
    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.2); /* Subtle shadow for depth */
  }

  .ctr-btn-primary:hover {
    background-color: #8cc540;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(79, 70, 229, 0.25);
  }

  .ctr-btn-primary:active {
    transform: translateY(0); /* Reset transform on click */
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.15);
  }

  .ctr-btn-secondary {
    border: 1px solid #d1d5db;
    color: #374151;
    background-color: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .ctr-btn-secondary:hover {
    background-color: #f9fafb;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .ctr-btn-secondary:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  /* Error message styles */
  .ctr-error-message {
    background-color: #fef2f2; /* Softer error background */
    border-left: 4px solid #ef4444;
    color: #b91c1c;
    padding: 1rem;
    border-radius: 8px;
    font-size: 0.875rem;
    margin-bottom: 1.5rem;
  }

  /* Results section */
  .ctr-results {
    margin-top: 2.5rem;
    padding-top: 2.5rem;
    border-top: 1px solid #e5e7eb;
    animation: ctrFadeIn 0.5s ease-out;
  }

  @keyframes ctrFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .ctr-fs-4 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a202c;
    margin-bottom: 1.5rem;
  }

  .ctr-results-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    margin-bottom: 2.5rem;
  }

  .ctr-result-card {
    background: linear-gradient(
      145deg,
      #ffffff,
      #f9fafb
    ); /* Subtle gradient for depth */
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    width: 100%;
  }

  .ctr-result-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  }

  .ctr-result-header {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .ctr-result-value {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    background: linear-gradient(135deg, #4f46e5, #4338ca);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .ctr-result-status {
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    display: inline-block;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .ctr-status-poor {
    background-color: #fef2f2;
    color: #ef4444;
    border: 1px solid #fecaca;
  }

  .ctr-status-good {
    background-color: #fefce8;
    color: #d97706;
    border: 1px solid #fef08a;
  }

  .ctr-status-excellent {
    background-color: #f0fdf4;
    color: #10b981;
    border: 1px solid #86efac;
  }

  .ctr-result-benchmark {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: #4f46e5;
  }

  .ctr-result-industry {
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .ctr-result-potential {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: #10b981;
  }

  .ctr-result-improvement {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    display: inline-block;
  }

  .ctr-positive {
    background-color: #f0fdf4;
    color: #10b981;
    border: 1px solid #86efac;
  }

  .ctr-neutral {
    background-color: #f3f4f6;
    color: #6b7280;
    border: 1px solid #d1d5db;
  }

  /* Recommendations section */
  .ctr-recommendations {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    margin-top: 2.5rem;
  }

  .ctr-fs-5 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1a202c;
    margin-bottom: 1.5rem;
  }

  .ctr-recommendations ul {
    list-style: none;
    display: grid;
    gap: 1rem;
    padding: 0;
  }

  .ctr-recommendations li {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #4b5563;
    font-size: 0.875rem;
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 10px;
    transition: all 0.2s ease;
  }

  .ctr-recommendations li:hover {
    background-color: #e5e7eb;
    transform: translateX(5px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .ctr-recommendations li::before {
    content: "•";
    color: #4f46e5;
    font-weight: bold;
    font-size: 1.25rem;
    line-height: 1;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ctr-container {
      padding: 1.5rem 0rem;
    }

    .ctr-calculator-card {
      padding: 0.5rem;
    }

    .ctr-fs-2 {
      font-size: 1.75rem;
    }

    .ctr-fs-4 {
      font-size: 1.25rem;
    }

    .ctr-fs-5 {
      font-size: 1rem;
    }

    .ctr-form-grid {
      grid-template-columns: 1fr;
    }

    .ctr-button-group {
      flex-direction: column;
      gap: 0.75rem;
    }

    .ctr-btn {
      width: 100%;
    }

    .ctr-results-grid {
      grid-template-columns: 1fr;
    }
    .ctr-recommendations {
      padding: 1rem 0.75rem;
    }
    .ctr-recommendations li {
      padding: 0.75rem;
    }
    .ctr-btn-secondary {
      order: 2;
    }
  }

  @media (max-width: 640px) {
    .ctr-form-grid {
      grid-template-columns: 1fr;
    }

    .ctr-button-group {
      grid-column: 1;
    }

    .ctr-results-grid {
      grid-template-columns: 1fr;
    }

    .ctr-result-value {
      font-size: 1.125rem;
    }

    .ctr-recommendations li {
      padding: 0.5rem;
    }
  }
`;
